import i18n from 'i18n';
import { SiteAnnouncementType } from 'core/siteAnnouncement/SiteAnnouncement';
import styles from './siteAnnouncementTypeCapsule.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export const SiteAnnouncementTypeCapsule: React.FC<{
  type: SiteAnnouncementType;
}> = ({ type }) => {
  const typeKey = SiteAnnouncementType[type].toLowerCase();
  return (
    <div className={styles.capsules}>
      <div className={cx('capsule', typeKey)}>
        {i18n.t(`siteAnnouncement.types.${typeKey}`)}
      </div>
    </div>
  );
};
